// Virtual-consultation reservations, payments, intake answers and video (v1).
import api, {withIdempotencyKey} from './client';

// Mutating calls take an optional `{idempotencyKey}` (see hooks/useIdempotencyKeys); without it
// the client generates a fresh key per request.

export const getReservationList = (period) =>
  api.get(`/me/reservations${period ? `?period=${period}` : ''}`).then((r) => r.data);

export const getReservation = (id) => api.get(`/reservations/${id}`).then((r) => r.data);

export const createReservation = (d, opts = {}) =>
  api.post('/me/reservations', d, withIdempotencyKey(opts.idempotencyKey)).then((r) => r.data);

/** Cancels; paid consultations are refunded in full. Pass `{idempotencyKey}` to replay a retry. */
export const deleteReservation = (id, opts = {}) =>
  api
    .post(`/reservations/${id}/cancel`, undefined, withIdempotencyKey(opts.idempotencyKey))
    .then((r) => r.data);

export const getAnswers = (reservationId) =>
  api.get(`/reservations/${reservationId}/answers`).then((r) => r.data);

/** Legacy signature: answers are now listed per reservation. */
export const getAnswer = (reservationId) => getAnswers(reservationId);

export const submitAnswer = (reservationId, formAndQuestionId, answer, opts = {}) =>
  api
    .post(
      `/reservations/${reservationId}/answers`,
      {form_and_question_id: formAndQuestionId, answer},
      withIdempotencyKey(opts.idempotencyKey),
    )
    .then((r) => r.data);

export const getForm = (formId) => api.get(`/forms/${formId}`).then((r) => r.data);

export const createPayment = (id, opts = {}) =>
  api
    .post(`/reservations/${id}/payment`, undefined, withIdempotencyKey(opts.idempotencyKey))
    .then((r) => r.data);

export const confirmPayment = (id, opts = {}) =>
  api
    .post(`/reservations/${id}/payment/confirm`, undefined, withIdempotencyKey(opts.idempotencyKey))
    .then((r) => r.data);

export const getVideoToken = (id) => api.get(`/reservations/${id}/video-token`).then((r) => r.data);

export const getDoctorQueue = (status = 'pending') =>
  api.get(`/doctor/reservations?status=${status}`).then((r) => r.data);

export const decideReservation = (id, decision, notes = '') =>
  api.post(`/reservations/${id}/decision`, {decision, notes}).then((r) => r.data);
